export default "__VITE_ASSET__DgBVerSA__"